// The Home lists only the latest analyses; the rest is one click away on the operation pages.
export const MAX_RECENT_ANALYSES = 5;

const completedAt = (operation) => new Date(operation.completion_date).getTime();

// Completed analyses, most recently completed first (then higher id), capped.
export const pickRecentAnalyses = (operations, limit = MAX_RECENT_ANALYSES) => {
  if (!Array.isArray(operations)) return [];
  return operations
    .filter((operation) => operation?.type === "ANALYSIS" && operation.completion_date)
    .sort((a, b) => completedAt(b) - completedAt(a) || b.id - a.id)
    .slice(0, limit);
};
